export default function trailingSlash(url) {
  return url ? (url.slice(-1) === '/' ? url : `${url}/`) : undefined
}

export function removeTrailingSlash(url) {
  return url.replace(/\/+$/, '') ?? url
}
